module.exports = __webpack_public_path__ + "static/media/FiraMono-Medium.5f85e0d1.ttf";